/** @format */

import React, { Component } from "react";
import { Card, Form, Container, Row, Col, Button } from "react-bootstrap";
import {
  EnforcementActions,
  CurrentPermitActions,
  ResidentsActions,
  SelfRegisterActions,
} from "../../Actions";
import { connect } from "react-redux";
import CustomContentAlert, {
  regExForPhone,
  removeSpecialChar,
  validations,
} from "../helper";
import moment from "moment";
import NoteSelector from "../SelfRegister/NoteSelector";

class AddQuickPermit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicle_license: "",
      first_name: "",
      last_name: "",
      phone: "",
      memberId: "",
      isFormValid: false,
      userDetails:
        this.props.UserProfileDetails &&
        Object.keys(this.props.UserProfileDetails).length
          ? this.props.UserProfileDetails
          : this.props.semiAuthorizedUserProfile,
      residentList_: [],
      selectedValue: {},
      selected_suite_id: "",
      lots: {},
      permit_start_date: "",
      permit_end_date: "",
      api_success_message: "",
      api_error_message: "",
      notes: "",
      country_code: "",
      country_code_list: [
        { text: "+1", value: "+1" },
        { text: "+91", value: "+91" },
        { text: "+44", value: "+44" },
        { text: "+61", value: "+61" },
      ],
      phone_options: [],
    };
  }

  componentDidMount = async () => {
    const currentdate = new Date().toLocaleString("en-US", {
      timeZone: this.props.timezone,
    });
    const formatEndDate = moment(currentdate).format("YYYY-MM-DD");
    const endDateWithTime = `${formatEndDate} 23:59:59`;
    const formatedET = moment(endDateWithTime).format("YYYY-MM-DD HH:mm:SS");
    const convertedExpireTime = moment
      .tz(formatedET, this.props.timezone)
      .format();
    const UTCET = moment.tz(convertedExpireTime, "UTC").format();
    this.setState({
      permit_end_date: UTCET,
    });
    this.props.getQuickPermitSetup(this.props.property_id);
  };

  handleAddPhoneOptions = () => {
    console.log("handleAddPhoneOptions called::---");
    const { phone_options } = this.state;

    this.setState(
      {
        phone_options: [...phone_options, { country_code: "+1", phone: "" }],
      },
      async () => {
        this.validateForm();
      }
    );
  };

  removePhoneOption = (index) => {
    const { phone_options } = this.state;
    console.log("index", index);

    this.setState(
      {
        phone_options: [...phone_options.filter((_x, i) => i !== index)],
      },
      async () => {
        this.validateForm();
      }
    );
  };

  handlePhoneOptions = (index, value, type) => {
    console.log("index, value :::::", index, value, type);
    const { phone_options } = this.state;
    console.log("phone_options:::", phone_options);

    let phone_values;
    let country_code_values;

    if (type === "phone_number_options") {
      phone_values = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      phone_options[index].phone = phone_values;
    }
    if (type === "country_code_options") {
      country_code_values = value;
      phone_options[index].country_code = country_code_values;
    }

    this.setState(
      {
        phone_options: [...phone_options],
      },
      async () => {
        this.validateForm();
      }
    );

    console.log("phone_options::::", phone_options);
  };

  isMultiplePhoneValid = () => {
    const { phone_options } = this.state;

    const validPhone = phone_options?.map((options) => {
      if (
        options.phone?.trim().length > 10 ||
        options.phone?.trim().length < 10 ||
        options.phone?.trim().length === 0
      ) {
        return !(
          options.phone?.trim().length > 10 ||
          options.phone?.trim().length < 10 ||
          options.phone?.trim().length === 0
        );
      }
      return true;
    });
    console.log("validPhone:::", validPhone);
    return !validPhone?.includes(false);
  };

  handleChange = ({ target }) => {
    const prevstate = this.state.phone;
    this.setState({ [target.name]: target.value }, () => {
      const { phone } = this.state;
      if (target.name === "phone" && phone.trim().length) {
        this.validateContactNumber();
        if (regExForPhone.test(target.value)) {
          this.setState({ phone: target.value });
        } else {
          this.setState({ phone: prevstate });
        }
      }
      const FirstName = validations(
        target.name,
        "first_name",
        this.state.first_name
      );
      this.setState({
        first_name: removeSpecialChar(FirstName.value),
      });

      const LastName = validations(
        target.name,
        "last_name",
        this.state.last_name
      );
      this.setState({
        last_name: removeSpecialChar(LastName?.value),
      });
      const CountryCode = validations(
        target.name,
        "country_code",
        this.state.country_code
      );
      this.setState({
        country_code: CountryCode?.value?.replace(/[a-zA-Z]/, ""),
      });
      const Phone = validations(target.name, "phone", this.state.phone);
      this.setState({
        phone: Phone?.value?.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"),
      });

      const MemberId = validations(
        target.name,
        "memberId",
        this.state.memberId
      );
      this.setState({
        memberId: removeSpecialChar(MemberId.value),
      });

      const Notes = validations(target.name, "notes", this.state.notes);
      this.setState({
        notes: Notes.value,
      });

      const VehicalLicense = validations(
        target.name,
        "vehicle_license",
        this.state.vehicle_license
      );

      this.setState({
        vehicle_license: VehicalLicense.value
          .toUpperCase()
          .replace(/[^a-zA-Z0-9]/g, ""),
      });
      this.validateForm();
    });
  };

  validateContactNumber = () => {
    const { phone } = this.state;
    const regExForContactNumber = regExForPhone;
    const isContactNumberValidate = regExForContactNumber.test(String(phone));
    if (isContactNumberValidate) {
      if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
        this.setState({
          phoneErrorMessage: "Please enter valid phone number",
        });
        return false;
      } else {
        this.setState({
          phoneErrorMessage: "",
        });
        return true;
      }
    } else {
      return false;
    }
  };

  validateForm = () => {
    const { first_name, last_name, phone, vehicle_license } = this.state;
    if (this.props?.quickPermitSetupDetail?.show_id === 0) {
      console.log("if part called::::");
      if (
        first_name?.trim()?.length &&
        last_name?.trim()?.length &&
        phone?.trim()?.length &&
        vehicle_license?.trim()?.length &&
        this.validateContactNumber() &&
        this.isMultiplePhoneValid()
      ) {
        this.setState({
          isFormValid: true,
        });
      } else {
        this.setState({
          isFormValid: false,
        });
      }
    } else {
      console.log("else part called::::");
      if (
        first_name?.trim()?.length &&
        last_name?.trim()?.length &&
        vehicle_license?.trim()?.length &&
        phone?.trim()?.length === 10 &&
        this.isMultiplePhoneValid()
      ) {
        this.setState({
          isFormValid: true,
        });
      } else {
        this.setState({
          isFormValid: false,
        });
      }
    }
  };

  handleSubmit = async () => {
    const {
      vehicle_license,
      first_name,
      last_name,
      phone,
      permit_start_date,
      permit_end_date,
      notes,
      memberId,
      country_code,
      phone_options,
    } = this.state;
    const residentData = {
      first_name,
      last_name,
      phone,
      suite_id: "Quick Permit",
      memberId: memberId,
      country_code,
      phone_options,
    };
    const PropertyId = this.props.property_id;
    this.setState({ isFormValid: false });
    let selfServe;
    if (this.props?.allPermissions !== []) {
      selfServe = false;
    } else {
      selfServe = true;
    }
    const obj = {
      ...residentData,
      vehicle_license,
      self_server: selfServe,
      notes: notes,
      lot_id: this.props?.quickPermitSetupDetail?.lot_id,
      call_when_here: 0,
    };
    await this.props.visitorCreate(
      PropertyId,
      permit_start_date,
      permit_end_date,
      this.props.id,
      obj,
      ["lotid"],
      true,
      this.props.timezone
    );
    if (this.props.api_response) {
      this.setState({
        selectedValue: {},
        last_name: "",
        first_name: "",
        notes: "",
        memberId: "",
        phone: "",
        vehicle_license: "",
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      setTimeout(() => {
        this.setState({ show_alert: false, phone_options: [] });
      }, 4000);
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  findPermit = async () => {
    const { memberId, phone } = this.state;
    if (memberId || phone) {
      await this.props.getPermitDataWithPhoneOrMemberID(
        phone,
        memberId,
        this.props.property_id
      );
      if (
        this.props.api_response &&
        this.props.quickPermitDetail &&
        Object.keys(this.props.quickPermitDetail).length > 0
      ) {
        this.setState({
          phone: this.props.quickPermitDetail.phone,
          first_name: this.props.quickPermitDetail.firstName,
          last_name: this.props.quickPermitDetail.lastName,
          vehicle_license: this.props.quickPermitDetail.plate,
          notes: this.props.quickPermitDetail.note,
          isFormValid: true,
          phone_options: this.props.quickPermitDetail.phone_options,
        });
      }
    }
  };

  blockInvalidChar = (e) => {
    return ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
  };

  render() {
    const {
      first_name,
      last_name,
      phone,
      vehicle_license,
      isFormValid,
      memberId,
      api_success_message,
      api_error_message,
      show_alert,
      show_error,
      notes,
      country_code,
      country_code_list,
      phoneErrorMessage,
      phone_options,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="contact-container mb-0">
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Card.Title as="h4">Quick permits</Card.Title>
                  <p className="card-category"></p>
                </Card.Header>
                <Card.Body>
                  <Row>
                    {this.props?.quickPermitSetupDetail?.show_id === 1 && (
                      <Col md={6} xs={6}>
                        <Form.Label>Member ID:</Form.Label>
                        <Form.Control
                          value={memberId}
                          type="string"
                          name="memberId"
                          placeholder="Member ID"
                          onChange={this.handleChange}
                        ></Form.Control>
                      </Col>
                    )}
                    {this.props?.quickPermitSetupDetail?.show_id === 0 && (
                      <Col md={6} xs={6}>
                        <Form.Label>Mobile:</Form.Label>
                        <span className="asterisk">*</span>
                        <Form.Control
                          value={phone}
                          type="text"
                          name="phone"
                          pattern="[0-9]*"
                          placeholder="333-222-2323"
                          notes
                          onChange={this.handleChange}
                          maxlength="10"
                        />
                      </Col>
                    )}
                    <Col className="mt-4">
                      <Button onClick={this.findPermit}>Find</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} xl={6}>
                      <Form.Label>License Plate Number:</Form.Label>
                      <span className="asterisk">*</span>
                      <Form.Control
                        type="text"
                        name="vehicle_license"
                        value={vehicle_license}
                        placeholder="ABC123"
                        onChange={this.handleChange}
                        maxlength="11"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} xl={6}>
                      <Form.Label>Permit Name:</Form.Label>
                      <span className="asterisk">*</span>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: " 1fr 1fr",
                          gridColumnGap: "15px",
                        }}
                      >
                        <Col style={{ padding: 0 }}>
                          <Form.Label>First Name:</Form.Label>
                          <Form.Control
                            value={first_name}
                            type="string"
                            name="first_name"
                            placeholder="First Name"
                            onChange={this.handleChange}
                          />
                        </Col>
                        <Col style={{ padding: 0 }}>
                          <Form.Label>Last Name:</Form.Label>
                          <Form.Control
                            value={last_name}
                            type="string"
                            name="last_name"
                            placeholder="Last Name"
                            onChange={this.handleChange}
                          />
                        </Col>
                      </div>
                    </Col>
                  </Row>

                  {this.props?.quickPermitSetupDetail?.regular === 1 && (
                    <Row>
                      <Col md={6} xs={6}>
                        <NoteSelector
                          setNote={(note) => this.setState({ notes: note })}
                          note={notes}
                          quickPermitSetupDetail={
                            this.props.quickPermitSetupDetail
                          }
                        />
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label>Country Code:</label>
                        <Form.Control
                          as="select"
                          name="country_code"
                          onChange={this.handleChange}
                          value={country_code}
                        >
                          {country_code_list ? (
                            <>
                              {country_code_list.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.text}
                                </option>
                              ))}
                            </>
                          ) : null}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Label>Mobile:</Form.Label>
                      <span className="asterisk">*</span>
                      <Form.Control
                        value={phone}
                        type="text"
                        name="phone"
                        // pattern="[0-9]*"
                        placeholder="333-222-2323"
                        notes
                        onKeyDown={this.blockInvalidChar}
                        onChange={this.handleChange}
                        maxlength="10"
                        autoComplete="off"
                      />
                      <span className="help-block">{phoneErrorMessage}</span>
                    </Col>
                    <Col md="2">
                      <Button
                        size="sm"
                        className="ml-3 mt-4"
                        disabled={
                          phone_options?.length > 9 ||
                          phone?.trim()?.length === 0 ||
                          phone?.trim()?.length > 10 ||
                          phone?.trim()?.length < 10 ||
                          !this.isMultiplePhoneValid()
                        }
                        onClick={this.handleAddPhoneOptions}
                      >
                        <i className="fas fa-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col md="5"></Col>
                  </Row>
                  {phone_options &&
                    typeof phone_options === "object" &&
                    Array.isArray(phone_options) &&
                    phone_options.map((option, index) => {
                      return (
                        <Row key={index} className="my-0">
                          <Col className="" md="3">
                            <Form.Group>
                              <Form.Control
                                as="select"
                                name="country_code_options"
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "country_code_options"
                                  )
                                }
                                value={option?.country_code}
                                required
                              >
                                {country_code_list ? (
                                  <>
                                    {country_code_list.map((item) => (
                                      <option
                                        key={item.text}
                                        value={item.value}
                                      >
                                        {item.text}
                                      </option>
                                    ))}
                                  </>
                                ) : null}
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col className="" md="3">
                            <Form.Group className="p-0 m-1">
                              {/* <Form.Label>Option {index + 1}</Form.Label> */}
                              {/* <span className="asterisk">*</span> */}
                              <Form.Control
                                placeholder="Phone Number"
                                type="text"
                                name="phone_number_options"
                                value={option?.phone}
                                // onBlur={(e) => e.target.value.trim() === "" && removeNoteOption(index)}
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "phone_number_options"
                                  )
                                }
                                maxLength="10"
                                autoComplete="off"
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3" className="mt-2">
                            <Button
                              size="sm"
                              className="ml-2"
                              onClick={() => this.removePhoneOption(index)}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>
                          </Col>
                        </Row>
                      );
                    })}
                  <Row>
                    <Col
                      style={{
                        padding: "15px 0 0 15px",
                      }}
                      md={6}
                      xs={6}
                    >
                      <Button
                        disabled={!isFormValid}
                        onClick={this.handleSubmit}
                      >
                        Create
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col></Col>
          </Row>
          {show_alert && (
            <CustomContentAlert
              delay={4000}
              message={api_success_message}
              className="toast-success"
            />
          )}
          {show_error && (
            <CustomContentAlert
              delay={4000}
              message={api_error_message}
              className="toast-error"
            />
          )}
        </Container>
      </div>
    );
  }
}
const mapStateToProps = ({
  CurrentPermitDetails,
  ResidenDetails,
  UserProfileDetails,
  APIResponseDetails,
  EnforcementDetails,
  Logindetails,
  SelfRegisterDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { id, property_id, property, timezone } = UserProfileDetails;
  const { allUsers, userlots } = EnforcementDetails;
  const { semiAuthorizedUserProfile } = Logindetails;
  const { residentList } = CurrentPermitDetails;
  const { addNewResident } = ResidenDetails;
  const { quickPermitSetupDetail, quickPermitDetail } = SelfRegisterDetails;
  return {
    quickPermitDetail,
    UserProfileDetails,
    semiAuthorizedUserProfile,
    api_response,
    api_error_message,
    api_success_message,
    id,
    property_id,
    property,
    allUsers,
    userlots,
    residentList,
    addNewResident,
    timezone,
    quickPermitSetupDetail,
  };
};

const mapStateToDispatch = {
  getUserLots: EnforcementActions.get_user_lots,
  getQuickPermitSetup: SelfRegisterActions.getQuickPermitSetup,
  fetchResidentList: CurrentPermitActions.fetchResidentList,
  getResidentDetails: ResidentsActions.getResidentDetails,
  visitorCreate: ResidentsActions.visitorCreate,
  getPermitDataWithPhoneOrMemberID:
    SelfRegisterActions.getPermitDataWithPhoneOrMemberID,
};

export default connect(mapStateToProps, mapStateToDispatch)(AddQuickPermit);
